module.exports = __webpack_public_path__ + "static/media/img_fenlei14.f6725245.png";